<template>
    <md-dialog v-bind:class="'theme-' + (theme || 'default')"
               style="z-index:501"
               :md-active.sync="active"
               :md-backdrop="backdrop"
               :md-close-on-esc="closeOnEsc"
               :md-click-outside-to-close="clickOutsideToClose"
               :md-fullscreen="fullscreen"
               @md-closed="onClosed"
               @md-opened="onOpened"
               @md-clicked-outside="onClickedOutside">
        <md-dialog-title class="title">{{title}}</md-dialog-title>
        <md-dialog-content class="content" v-html="content"></md-dialog-content>
        <md-dialog-actions class="actions">
            <md-button v-for="(item,index) in buttons" v-bind:key="index" :class="item.class + ' md-dense'" @click="item.click">{{item.text}}</md-button>
        </md-dialog-actions>
    </md-dialog>
</template>

<script>
    import CustomModal from './plugin.js';

    function getDefaultData() {
        return {
            active: false,
            backdrop: true,
            closeOnEsc: true,
            clickOutsideToClose: true,
            fullscreen: true,
            title: 'Atenção',
            theme: 'Default',
            content: '...',
            buttons: []
        }
    }

    export default {
        name: 'TemplateModal',
        data: getDefaultData,
        methods: {
            info(content) {
                this.active = true;
                this.clickOutsideToClose = false;
                this.theme = 'primary';
                this.content = '<div style="font-size: large;">' + content + '</div>';
                this.buttons = [{
                    text: 'Ok',
                    class: 'md-raised theme-' + this.theme,
                    click: () => {
                        this.active = false;
                    }
                }];
            },
            alert(msg, details, callBack) {
                this.active = true;
                this.clickOutsideToClose = false;
                this.title = 'Atenção';
                this.theme = 'warning';

                this.content = '<div style="font-size: large;">' + msg + '</div>';
                if (details)
                    this.content += '<div style="margin-top: 16px; font-size: smaller; line-height: 16px; color: gray;">'
                        + '    <div><strong>Detalhes:</strong></div>'
                        + '    <div>' + details + '</div>'
                        + '</div> ';

                this.buttons = [{
                    text: 'Ok',
                    class: 'md-raised theme-' + this.theme,
                    click: () => {
                        this.active = false;
                        if (callBack)
                            callBack();
                    }
                }];
            },
            error(msg, details) {
                this.active = true;
                this.clickOutsideToClose = false;
                this.title = 'Ops...';
                this.theme = 'danger';

                this.content = '<div style="font-size: large;">' + msg + '</div>';
                if (details)
                    this.content += '<div style="margin-top: 16px; font-size: smaller; line-height: 16px; color: gray;">'
                        + '    <div><strong>Detalhes:</strong></div>'
                        + '    <div>' + details + '</div>'
                        + '</div> ';

                this.buttons = [{
                    text: 'Ok',
                    class: 'md-raised theme-danger s-h3',
                    click: () => {
                        this.active = false;
                    }
                }];
            },
            confirm(content, callBackOnConfirm) {
                this.active = true;
                this.content = content;
                this.theme = 'primary';

                this.buttons = [{
                    text: 'Confirmar',
                    class: 'md-raised md-primary',
                    click: () => {
                        this.active = false;
                        callBackOnConfirm();
                    }
                },
                {
                    text: 'Abandonar',
                    class: 'md-raised md-accent',
                    click: () => {
                        this.active = false;
                    }
                }];
            },
            custom(content, buttonList) {
                this.active = true;
                this.content = content;
                this.theme = "custom";
                console.log(content)
                console.log(buttonList)

                this.buttons = []
                if (buttonList) {
                for (let but of buttonList) {
                    this.buttons.push(
                        { ...but, click: () => { but.action(); this.active = false }}
                    )
                }

                }
                console.log(this.buttons)

            },
            onClosed() {
                Object.assign(this.$data, getDefaultData());
            },
            onOpened() {

            },
            onClickedOutside() {

            }
        },
        beforeMount() {
            CustomModal.EventBus.$on('info', (content) => {
                this.info(content);
            });

            CustomModal.EventBus.$on('alert', (params) => {
                this.alert(params.msg, params.details, params.callBack);
            });

            CustomModal.EventBus.$on('error', (params) => {
                this.error(params.msg, params.details);
            });

            CustomModal.EventBus.$on('confirm', (params) => {
                this.confirm(params.content, params.callBackOnConfirm);
            })

            CustomModal.EventBus.$on('custom', (params) => {
                this.custom(params.content, params.buttons);
            })
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .md-button {
        overflow: visible !important;
    }

    .title {
        padding: 16px 16px 16px 16px;
    }

    .theme-custom .content {
        margin: 25px 7px 2px 4px;
        color: #777171
    }

    .md-dialog.theme-custom {
        width: 627px;
        left: calc(50% - 313px);
    }
    

        .theme-custom .content:before {
            content: '\e002';
            color: #FFB300;
            display: inline-block;
            font-family: 'Material Icons', Arial, sans-serif;
            font-size: 20px;
            font-style: normal;
            font-weight: normal;
            letter-spacing: normal;
            line-height: 1;
            text-transform: none;
            white-space: nowrap;
            word-wrap: normal;
            -webkit-font-feature-settings: 'liga';
            -webkit-font-smoothing: antialiased;
            margin-right: 10px;
            margin-bottom: -5px;
            position: inherit;
            top: 6px;
        }

    /*Css Theme - Title*/
    .theme-default .title {
        background-color: #EEF2F6 !important;
        color: white !important;
    }

    .theme-custom .title {
        display:none !important
    }

    .theme-primary .title {
        background-color: #6361FB !important;
        color: white !important;
    }

    .theme-success .title {
        background-color: #009688 !important;
        color: white !important;
    }

    .theme-danger .title {
        background-color: #FF0000 !important;
        color: white !important;
    }

    .theme-warning .title {
        background-color: #FFB300 !important;
        color: white !important;
    }

    /*Css Theme - Actions*/
    .theme-default .actions {
        border-top: solid 1px #EEF2F6 !important;
    }

    .theme-primary .actions {
        border-top: solid 1px #6361FB !important;
    }

    .theme-success .actions {
        border-top: solid 1px #009688 !important;
    }

    .theme-danger .actions {
        border-top: solid 1px #FF0000 !important;
    }

    .theme-warning .actions {
        border-top: solid 1px #FFB300 !important;
    }

    /*Css buttons*/
    button.theme-default {
        background-color: #EEF2F6 !important;
        color: white !important;
    }

    button.theme-primary {
        background-color: #6361FB !important;
        color: white !important;
    }

    button.theme-success {
        background-color: #009688 !important;
        color: white !important;
    }

    button.theme-danger {
        background-color: #FF0000 !important;
        color: white !important;
    }

    button.theme-warning {
        background-color: #FFB300 !important;
        color: white !important;
    }
</style>

<style>
    /*Fix do z-index do overlay da modal*/
    /*.md-overlay.md-fixed, body > .md-overlay {
        z-index: 500;
    }*/
</style>
